<template>
  <div class="big">
    <DocMsg :isFlag="doc_msg" :doctorId="doctorId"></DocMsg>
    <ReturnVisit
      :isFlag="return_visit"
      :businessId="preId"
      :visitType="visitType"
      :visitName="visitName"
      :sms_type="2"
      :activeIndexDia="activeIndexDia"
    ></ReturnVisit>
    <div class="page_title flex_between">
      <span>
        <span>订单详情</span>
        <span class="remark">
          <span
            >备注（
            <span v-if="detail.platform_hospital_remark">
              {{ detail.platform_hospital_remark }}
            </span>
            <el-button
              v-else
              type="text"
              @click="
                hospitalremark = true;
                platform_hospital_remark = '';
              "
              :disabled="
                module_id_array[0] ? !module_id_array.includes('678') : false
              "
              >填写</el-button
            >
            <el-button
              v-if="detail.platform_hospital_remark"
              type="text"
              @click="
                platform_hospital_remark = detail.platform_hospital_remark;
                hospitalremark = true;
              "
              :disabled="
                module_id_array[0] ? !module_id_array.includes('678') : false
              "
              >修改</el-button
            >
            ）
          </span>
          <span style="margin-left: 20px">
            加急：
            <el-radio
              v-model="detail.platform_urgent"
              :label="1"
              :disabled="
                module_id_array[0] ? !module_id_array.includes('1413') : false
              "
              >是</el-radio
            >
            <el-radio
              v-model="detail.platform_urgent"
              :label="0"
              :disabled="
                module_id_array[0] ? !module_id_array.includes('1413') : false
              "
              >否</el-radio
            >
            <el-button
              type="primary"
              size="mini"
              @click="setUrgent"
              :disabled="
                module_id_array[0] ? !module_id_array.includes('1413') : false
              "
              >保存</el-button
            >
          </span>

          <span style="margin-left: 20px">
            医生加急：
            <span style="font-weight: 400">
              <span v-if="detail.doctor_urgent">是</span>
              <span v-else>否</span>
            </span>
          </span>

          <span style="margin-left: 20px">
            是否分方：
            <span style="font-weight: 400">
              <span>{{ separateText(detail.is_separate) }}</span>
            </span>
            <el-button
              v-if="order_status == 2 || order_status == 3 || order_status == 4"
              style="margin-left: 10px"
              type="primary"
              size="mini"
              @click="separateDiaOpen"
              :disabled="
                module_id_array[0] ? !module_id_array.includes('1570') : false
              "
              >修改</el-button
            >
          </span>

          <!-- 是否已开具发票 -->
          <span style="margin-left: 20px">
            是否已开具发票：
            <el-radio-group
              v-model="detail.is_send_invoice"
              :disabled="
                module_id_array[0] ? !module_id_array.includes('1629') : false
              "
            >
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
            <el-button
              type="primary"
              size="mini"
              style="margin-left: 10px"
              @click="setIsInvoice"
              :disabled="
                module_id_array[0] ? !module_id_array.includes('1629') : false
              "
              >保存</el-button
            >
          </span>
        </span>
      </span>

      <el-button type="primary" style="width: 92px" size="medium" @click="back"
        >返回</el-button
      >
    </div>
    <!-- 物流详情弹窗 -->
    <el-dialog
      title="查看物流"
      :visible.sync="express"
      width="800px"
      style="text-align: left"
    >
      <div>
        <div style="padding: 24px 30px 20px 70px">
          <template>
            <div
              class="flex"
              style="align-items: center; justify-content: space-between"
            >
              <div>
                <div style="margin-bottom: 10px;">
                  <span style="color: #666;">配送方式：</span>
                  <span v-if="express_data.delivery == 1">快递</span>
                  <span v-if="express_data.delivery == 3">闪送</span>
                </div>
                <div>
                  <span style="color: #666">快递公司：</span>
                  <span>{{ express_data.express_name }}</span>
                </div>
                <div style="margin: 10px 0">
                  <span style="color: #666">{{
                    express_data.delivery == 3 ? "闪送订单号：" : "运单号："
                  }}</span>
                  <span>{{ express_data.express_no }}</span>
                </div>

                <div style="margin-bottom: 30px">
                  <span style="color: #666">{{
                    express_data.delivery == 3 ? "闪送员手机号：" : "联系电话："
                  }}</span>
                  <span>{{
                    express_data.delivery == 3
                      ? express_data.courier_phone
                      : express_data.express_phone
                  }}</span>
                </div>
              </div>
              <el-button
                type="primary"
                style="width: 120px; align-self: flex-start; margin-top: 10px"
                v-if="order_status == 3"
                @click="confirmReceipt"
                :disabled="
                  module_id_array[0] ? !module_id_array.includes('233') : false
                "
                >确认收货</el-button
              >
            </div>
          </template>

          <el-timeline>
            <el-timeline-item
              v-for="(item, index) in express_data.logistics_list"
              :key="index"
              :icon="item.icon"
              :type="item.type"
              :color="item.color"
              :size="item.size"
              :timestamp="item.time"
            >
              {{ item.context }}</el-timeline-item
            >
          </el-timeline>
        </div>
        <div style="text-align: right; padding: 0 20px 20px 0">
          <el-button type="primary" @click="express = false" style="width: 92px"
            >确定</el-button
          >
        </div>
      </div>
    </el-dialog>
    <div style="padding: 20px; border-radius: 5px">
      <div class="container">
        <div class="cancel" v-if="order_status == 5 || order_status == 7">
          <div style="font-size: 16px; font-weight: 600; margin-bottom: 14px">
            当前订单状态：
            <span v-if="order_status == 5"> 已取消(不通过)</span>
            <span v-if="order_status == 7"> 已取消(用户退款)</span>
            <el-button
              type="primary"
              size="medium"
              style="margin-left: 20px"
              @click="toReturn"
              :disabled="
                module_id_array[0] ? !module_id_array.includes('1315') : false
              "
              >回访
              <span v-if="detail.visit_count">({{ detail.visit_count }})</span>
            </el-button>
          </div>
          <div>
            <span>
              <span>取消原因：</span>
              <span v-if="order_status == 5">{{ detail.reject_desc }}</span>
              <span v-if="order_status == 7">用户退款</span>
            </span>
            <span style="margin: 0 30px">
              <span>售后状态：</span>
              <span>{{ detail.refund_status ? "已退款" : "未退款" }}</span>
            </span>
            <span v-if="detail.refund_status">
              <span>退款时间：</span>
              <span>{{ detail.refund_time }}</span>
            </span>
          </div>
        </div>

        <div
          style="padding-top: 30px; background: #fff"
          v-if="order_status != 5 && order_status != 7"
        >
          <div class="mystep_bar">
            <el-steps :active="active" align-center finish-status="success">
              <el-step></el-step>
              <el-step></el-step>
              <el-step></el-step>
              <el-step></el-step>
            </el-steps>

            <div class="step1">支付订单</div>
            <div
              class="step2"
              :style="
                order_status == 3 || order_status == 4
                  ? ' color: #669961;'
                  : 'color: #999'
              "
            >
              药房发货
            </div>
            <div
              class="step3"
              :style="active == 4 ? ' color: #669961;' : 'color: #999'"
            >
              客户收货
            </div>
            <div
              class="step4"
              :style="active == 4 ? ' color: #669961;' : 'color: #999'"
            >
              订单完成
            </div>
            <div class="steptext">
              <div>
                <div style="color: #999">{{ detail.create_time }}</div>
              </div>
              <div style="margin-left: 140px" v-if="active != 1">
                <div style="color: #999">{{ detail.send_time }}</div>
              </div>
              <div style="margin-left: 145px" v-if="active == 4">
                <div style="color: #999">{{ detail.completion_time }}</div>
              </div>
              <div style="margin-left: 140px" v-if="active == 4">
                <div style="color: #999">{{ detail.completion_time }}</div>
              </div>
            </div>
          </div>
          <div class="statusbox" v-if="order_status != 5">
            <div>
              <el-button
                style="margin-right: 10px"
                type="primary"
                @click="toReturn"
                :disabled="
                  module_id_array[0] ? !module_id_array.includes('1315') : false
                "
                >回访
                <span v-if="detail.visit_count"
                  >({{ detail.visit_count }})</span
                >
              </el-button>
              当前订单状态：
              <span v-if="order_status == 1">待审核</span>
              <span v-if="order_status == 2">待发货</span>
              <span v-if="order_status == 3">待收货</span>
              <span v-if="order_status == 4">已完成</span>
              <span v-if="order_status == 6">已取消（平台退款）</span>
              <span v-if="detail.abnormal_type == 1" style="color: red"
                >（平台异常）</span
              >
              <span v-if="detail.abnormal_type == 2" style="color: red"
                >（审方拒绝待处理）</span
              >
              <span v-if="detail.abnormal_type == 3" style="color: red"
                >（用户退款待处理）</span
              >
              <span v-if="detail.refund_abnormal == 2">
                <span>【继续等待</span>
                <span>({{ detail.refund_sub_time }})】</span>
              </span>
            </div>
            <div v-if="order_status == 4">
              收货类型：
              <span v-show="detail.completion_type == 1">自动收货</span>
              <span v-show="detail.completion_type == 2">患者确认收货</span>
              <span v-show="detail.completion_type == 3">平台确认收货</span>
              <span v-show="detail.completion_type == 4">顺丰自动签收</span>
              <span v-show="detail.completion_type == 5">闪送签收</span>
            </div>
            <div>
              <el-button
                type="primary"
                style="width: 120px"
                v-if="order_status == 3"
                @click="confirmReceipt"
                :disabled="
                  module_id_array[0] ? !module_id_array.includes('233') : false
                "
                >确认收货</el-button
              >
              <el-button
                type="primary"
                style="width: 120px"
                v-if="
                  (order_status == 1 || order_status == 2) &&
                  (detail.pre_group == 1 || detail.pre_group == 2) &&
                  detail.drug_machining != 2
                "
                @click="getreturnhospitalist"
                :disabled="
                  module_id_array[0] ? !module_id_array.includes('416') : false
                "
                >平台转单</el-button
              >
              <!-- v-if="(order_status == 3 || order_status == 4) && detail.delivery == 1" -->
              <el-button
                type="primary"
                style="width: 120px"
                v-if="
                  (order_status == 1 ||
                    order_status == 2 ||
                    order_status == 3 ||
                    order_status == 4) &&
                  (detail.delivery == 1 || detail.delivery == 3)
                "
                @click="orderExpress"
                :disabled="
                  module_id_array[0] ? !module_id_array.includes('115') : false
                "
                >流转记录</el-button
              >
            </div>
          </div>
        </div>

        <div>
          <!-- 基本信息 -->
          <div style="margin-top: 16px">
            <div style="margin-bottom: 12px">
              <span class="title">基本信息</span>
              <span
                v-if="detail.is_return == 2"
                style="margin-left: 10px; color: #ff0000"
                >转单</span
              >
              <span
                v-if="detail.gift_money > 2"
                style="margin-left: 10px; color: #ff0000"
                >礼品卡订单</span
              >
              <span style="margin-left: 10px; color: #ff7200">{{
                detail.sign_string
              }}</span>
            </div>
            <div class="infobox">
              <div style="display: flex">
                <div style="width: 260px">
                  <span>订单编号：</span>
                  <span>{{ detail.order_sn }}</span>
                </div>
                <div style="width: 260px">
                  <span>支付时间：</span>
                  <span>{{ detail.create_time }}</span>
                </div>
                <div style="width: 260px">
                  <span>支付方式：</span>
                  <span v-if="detail.pay_type == 1">微信</span>
                  <span v-if="detail.pay_type == 2">支付宝</span>
                  <span v-if="detail.pay_type == 10">线下支付</span>
                </div>
                <div style="width: 260px">
                  <span>支付来源：</span>
                  <span v-if="detail.pay_from == 1">公众号</span>
                  <span v-if="detail.pay_from == 2">患者App</span>
                  <span v-if="detail.pay_from == 3">小程序</span>
                </div>
                <div style="width: 260px">
                  <span>是否代付：</span>
                  <span v-if="detail.doctor_pay == 1">医生代付</span>
                  <span v-if="detail.doctor_pay == 2">好友代付</span>
                  <span v-if="detail.doctor_pay == 0">否</span>
                </div>
              </div>
              <div style="display: flex; margin: 20px 0">
                <div style="width: 520px">
                  <span>用户昵称：</span>
                  <span>{{ detail.nick_name }}</span>
                </div>
                <div style="width: 260px" class="align-center">
                  <span>用户手机号：</span>
                  <span>{{ detail.phone }}</span>
                  <img
                    v-if="
                      detail.phone &&
                      (module_id_array[0]
                        ? module_id_array.includes('1756')
                        : true)
                    "
                    class="phone-box"
                    src="https://qhyg-test-1258702188.cos.ap-chengdu.myqcloud.com/upload/common/20240521/171627515049458.png"
                    alt
                    @click="callBtn(5, detail.user_id)"
                  />
                </div>
              </div>
              <div style="display: flex">
                <div style="width: 260px">
                  <span>处方号：</span>
                  <span>{{ detail.pre_id }}</span>
                </div>
                <div style="width: 260px">
                  <span>患者姓名：</span>
                  <span>{{ detail.user_name }}</span>
                </div>
                <div>
                  <span>医生姓名：</span>
                  <span
                    style="cursor: pointer"
                    @click="showDocMsg(detail.doctor_id)"
                    >{{ detail.doctor_name }}</span
                  >
                </div>
              </div>
            </div>
          </div>
          <!-- 诊后病程管理 -->
          <div style="margin-top: 16px">
            <div style="margin-bottom: 12px">
              <span class="title">诊后病程管理</span>
            </div>
            <div
              class="infobox"
              style="display: flex; flex-wrap: wrap; gap: 10px 10px"
            >
              <div v-html="consultDrugOrderInfoText"></div>
              <template
                v-if="
                  Object.keys(detail).length &&
                  detail.consult_drug_order_info.status == 2 &&
                  detail.consult_drug_order_info.consult_id > 0
                "
              >
                <span>,&nbsp;&nbsp;正在诊后咨询中,&nbsp;&nbsp;</span>
                <el-link
                  type="primary"
                  :disabled="
                    module_id_array[0] ? !module_id_array.includes('50') : false
                  "
                  @click="toDetails(detail.consult_drug_order_info.consult_id)"
                  >查看详情</el-link
                >
              </template>
            </div>
          </div>
          <!-- 收获信息 -->
          <div>
            <div class="title">
              收货信息
              <span
                style="
                  color: #669961;
                  font-size: 14px;
                  cursor: pointer;
                  margin: 0 10px;
                "
                @click="showAddress"
                v-show="
                  (detail.status == 2 || detail.status == 1) &&
                  detail.delivery == 1
                "
                >修改地址</span
              >
              <span
                style="color: #669961; font-size: 14px; cursor: pointer"
                @click="showDeliveryBtn"
                v-show="order_status == 1 || order_status == 2"
                >修改配送方式</span
              >
            </div>
            <div
              class="infobox wrap"
              v-if="detail.delivery == 1 || detail.delivery == 3"
            >
              <div class="flex" style="margin-bottom: 15px">
                <div style="width: 260px">
                  <span>收货人：</span>
                  <span>{{ detail.address_info.consignee_name }}</span>
                </div>
                <div style="width: 260px">
                  <span>联系电话：</span>
                  <span>{{ detail.address_info.consignee_phone }}</span>
                </div>
                <div>
                  <span>收货地址：</span>
                  <span
                    >{{ detail.address_info.province_name
                    }}{{ detail.address_info.city_name
                    }}{{ detail.address_info.district_name
                    }}{{ detail.address_info.address }}</span
                  >
                </div>
              </div>
              <div class="flex">
                <div style="width: 260px">
                  <span>配送方式：</span>
                  <span v-if="detail.delivery == 1">快递</span>
                  <span v-if="detail.delivery == 3">闪送</span>
                </div>
                <div style="width: 260px" v-if="detail.delivery == 1">
                  <span>快递公司：</span>
                  <span>{{ detail.company_name }}</span>
                </div>
                <div
                  style="width: 260px"
                  v-if="detail.express_name && detail.delivery == 1"
                >
                  <span>快递公司（实际发货）：</span>
                  <span>{{ detail.express_name }}</span>
                </div>
              </div>
              <div class="flex align-center">
                <span v-if="detail.express_no && detail.delivery == 1">
                  <span>快递单号：</span>
                  <span>{{ detail.express_no }}</span>
                  <el-button
                    type="text"
                    style="margin-left: 10px; font-weight: 700"
                    @click="editOrder"
                    :disabled="
                      module_id_array[0]
                        ? !module_id_array.includes('406')
                        : false
                    "
                    >修改单号</el-button
                  >
                </span>
                <span
                  v-if="detail.completion_time && detail.delivery == 1"
                  style="margin-left: 50px"
                >
                  <span>收货时间：</span>
                  <span>{{ detail.completion_time }}</span>
                </span>
              </div>
              <div style="margin-top: 15px">
                <div v-if="detail.modify_receiving_goods_remark">
                  <span>修改收货信息备注：</span>
                  <span>{{ detail.modify_receiving_goods_remark }}</span>
                </div>
              </div>
            </div>
            <div class="infobox" v-if="detail.delivery == 2">
              <div>
                <span>自提地址：</span>
                <span style="color: #666"
                  >{{ detail.address_info.province_name
                  }}{{ detail.address_info.city_name
                  }}{{ detail.address_info.district_name
                  }}{{ detail.address_info.address }}</span
                >
              </div>
            </div>
          </div>
          <div style="margin-bottom: 10px" class="flex_between">
            <div>
              <span>
                <span class="title" style="margin-right: 20px">药品信息</span>
                <span v-if="detail.pre_group == 1">中药材</span>
                <span v-if="detail.pre_group == 2">中药材</span>
                <span v-if="detail.pre_group == 3">中药材</span>
                <span v-if="detail.pre_group == 4">中药材</span>
                <span v-if="detail.pre_group == 0">养生膏方</span>
                <span v-if="detail.pre_group == -1">成药</span>
                <span v-if="detail.pre_num > 1"
                  >（{{ detail.pre_sort }}/{{ detail.pre_num }}）</span
                >
                <template
                  v-if="
                    detail.pre_group == 1 ||
                    detail.pre_group == 2 ||
                    detail.pre_group == 3 ||
                    detail.pre_group == 4 ||
                    detail.pre_group == 5
                  "
                >
                  <el-button
                    style="margin-left: 10px"
                    type="primary"
                    size="mini"
                    @click="excelexport"
                    :disabled="
                      module_id_array[0]
                        ? !module_id_array.includes('1571')
                        : false
                    "
                    >导出药材及费用清单</el-button
                  >
                </template>
              </span>

              <el-button
                style="margin-left: 10px"
                type="primary"
                size="mini"
                @click="viewPrescription"
                :disabled="
                  module_id_array[0] ? !module_id_array.includes('56') : false
                "
                >查看处方</el-button
              >
            </div>

            <el-button
              type="primary"
              size="medium"
              @click="getRelation"
              :disabled="
                module_id_array[0] ? !module_id_array.includes('616') : false
              "
              v-if="detail.pre_num > 1"
              >查看关联订单</el-button
            >
          </div>
          <div>
            <span
              >剂型：{{ detail.drug_type_name }}
              <span v-if="detail.goods_drug_type_name"
                >（原料：{{ detail.goods_drug_type_name }}）</span
              ></span
            >
            <span v-if="detail.drug_machining == 1" style="margin-left: 20px"
              >代煎</span
            >
            <span v-if="detail.drug_machining == 2" style="margin-left: 20px"
              >茶包</span
            >
            <span style="margin-left: 40px">药房：</span>
            <span>{{ detail.hospital_name }}</span>
          </div>
          <div
            style="border: solid 1px #c9cbd6; margin-top: 20px"
            v-if="drugs_list.length > 0"
          >
            <!-- 中药材表格 -->
            <el-table
              ref="multipleTable"
              :data="drugs_list"
              tooltip-effect="dark"
              style="width: 100%"
              :header-cell-style="{ background: '#F5F5F5' }"
            >
              <el-table-column prop="generic_name" label="药品名称">
                <template slot-scope="scope">
                  <span>{{ scope.row.generic_name }}</span>
                  <span v-if="scope.row.is_national_standard == 1">(新)</span>
                  <span
                    v-if="
                      scope.row.is_national_standard == 1 &&
                      detail.is_sure_national_standard == 1 &&
                      scope.row.dosage_unit == 2
                    "
                    >(原{{ scope.row.item_use_level }}g)</span
                  >
                </template>
              </el-table-column>
              <el-table-column prop="item_use_level" label="开方量（按饮片）">
                <template slot-scope="scope">
                  <div
                    v-if="
                      scope.row.is_national_standard == 1 &&
                      detail.is_sure_national_standard == 1
                    "
                  >
                    {{ scope.row.national_standard_level }}
                  </div>
                  <span v-else>{{ scope.row.item_use_level }}g</span>
                </template>
              </el-table-column>
              <el-table-column label="规格" prop="sku_name"> </el-table-column>
              <el-table-column prop="conversion" label="当量"></el-table-column>
              <el-table-column label="单价" prop="price">
                <template slot-scope="scope">
                  <span>￥{{ scope.row.price }}</span>
                </template>
              </el-table-column>

              <el-table-column label="数量" prop="num">
                <template slot-scope="scope">
                  <span v-if="scope.row.dosage_unit != 2">{{
                    scope.row.num
                  }}</span>
                  <span v-else>{{ scope.row.num }}</span>
                </template>
              </el-table-column>
              <el-table-column label="金额">
                <template slot-scope="scope">
                  <span>￥{{ scope.row.money }}</span>
                </template>
              </el-table-column>
            </el-table>
          </div>

          <div class="totalprice" v-if="drugs_list.length > 0">
            <div>
              <span>共</span>
              <span style="margin: 0 3px; color: #669961">{{
                drugs_list.length
              }}</span>
              <span>味药材，共</span>
              <span style="margin: 0 3px; color: #669961">{{
                detail.total_num
              }}</span>
              <span>剂</span>
            </div>
            <div>
              <span style="color: #999">药品金额：</span>
              {{ detail.single_price }} x {{ detail.total_num }} =
              {{ detail.drug_price }}元
            </div>
          </div>
          <!-- 养生方 -->
          <div
            style="border: solid 1px #c9cbd6; margin-top: 20px"
            v-if="oil_list.length > 0"
          >
            <el-table
              ref="multipleTable"
              :data="oil_list"
              tooltip-effect="dark"
              style="width: 100%"
              :header-cell-style="{ background: '#F5F5F5' }"
            >
              <el-table-column
                prop="oil_name"
                label="膏方名称"
              ></el-table-column>
              <el-table-column label="规格" prop="oil_spec"></el-table-column>
              <el-table-column
                label="数量"
                prop="item_use_level"
              ></el-table-column>
            </el-table>
          </div>

          <div class="totalprice" v-if="oil_list.length > 0">
            <div>共{{ detail.oil_item_count }}件</div>
            <div>
              <span style="color: #999">药品金额：</span>
              {{ detail.ointment_price }}元
            </div>
          </div>

          <div
            style="border: solid 1px #c9cbd6; margin-top: 20px"
            v-if="pm_list.length > 0"
          >
            <!-- 成药表格 -->
            <el-table
              ref="multipleTable"
              :data="pm_list"
              tooltip-effect="dark"
              style="width: 100%"
              :header-cell-style="{ background: '#F5F5F5' }"
            >
              <el-table-column
                prop="pm_name"
                label="药品名称"
              ></el-table-column>
              <el-table-column label="规格" prop="pm_spec"> </el-table-column>
              <el-table-column label="单价" prop="price"> </el-table-column>
              <el-table-column label="单位" prop="pm_unit"> </el-table-column>
              <el-table-column label="数量" prop="item_use_level">
              </el-table-column>
              <el-table-column label="金额（元）">
                <template slot-scope="scope">
                  <span>{{
                    (scope.row.item_use_level * scope.row.price).toFixed(4)
                  }}</span>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div style="display: flex; justify-content: flex-end">
            <div>
              <div
                style="margin: 8px 0"
                class="price"
                v-if="Number(detail.drug_machining_price)"
              >
                <span>加工费：</span>
                <span style="color: #333; font-weight: 600"
                  >{{ detail.drug_machining_price }}元</span
                >
              </div>
              <div
                style="margin: 8px 0"
                class="price"
                v-if="detail.pre_group == 3"
              >
                <span>辅料费：</span>
                <span style="color: #333; font-weight: 600"
                  >{{ detail.excipients_price }}元</span
                >
              </div>

              <div style="margin: 8px 0" class="price">
                <span>诊后管理费：</span>
                <span style="color: #333; font-weight: 600"
                  >{{ detail.consult_drug_price }}元</span
                >
              </div>
              <div
                style="margin: 8px 0"
                v-if="pm_list.length > 0"
                class="price"
              >
                <span>成药：</span>
                <span style="color: #333; font-weight: 600"
                  >{{ detail.pm_price }}元</span
                >
              </div>
              <div style="margin: 8px 0" class="price">
                <span>诊金：</span>
                <span style="color: #333; font-weight: 600"
                  >{{ detail.consulting_gold }}元</span
                >
              </div>

              <div style="color: #666" class="price">
                <span>优惠金额：</span>
                <span style="color: #333; font-weight: 600"
                  >-{{ detail.discount_price }}元</span
                >
              </div>
              <div style="margin: 8px 0" class="price">
                <span>运费：</span>
                <span style="color: #333; font-weight: 600"
                  >{{ detail.freight_price - detail.freight_coupon_money }}元

                  <!-- <span v-if="detail.freight_coupon_id"
                    >&nbsp;优惠券抵扣{{ detail.freight_coupon_money }}元</span
                  > -->
                  <span>{{
                    detail.freight_price_type | freight_price_type_text
                  }}</span>
                </span>
              </div>
              <div style="margin: 8px 0" class="price">
                <span>礼品卡金额：</span>
                <span style="color: #333; font-weight: 600"
                  >-{{ detail.gift_money }}元</span
                >
              </div>
              <div class="price">
                <span>合计：</span>
                <span style="color: #ce5141; font-weight: 600"
                  >{{ detail.pay_money }}元</span
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 修改地址弹窗 -->
    <el-dialog
      title="修改地址"
      :visible.sync="addressShow"
      width="700px"
      :close-on-click-modal="false"
    >
      <div class="content bb">
        <p class="top">原收货信息</p>
        <div class="flex info">
          <div>
            <span class="label">收货人</span>
            <span class="text">{{ orderAddressInfo.consignee_name }}</span>
          </div>
          <div>
            <span class="label">联系电话</span>
            <span class="text">{{ orderAddressInfo.consignee_phone }}</span>
          </div>
        </div>
        <div class="flex info">
          <div>
            <span class="label">省市区县</span>
            <span class="text"
              >{{ orderAddressInfo.province_name
              }}{{ orderAddressInfo.city_name
              }}{{ orderAddressInfo.district_name }}</span
            >
          </div>
        </div>
        <div class="flex info">
          <div>
            <span class="label">详细地址</span>
            <span class="text">{{ orderAddressInfo.address }}</span>
          </div>
        </div>
        <div class="flex info">
          <div>
            <span class="label">配送方式</span>
            <span class="text">快递</span>
          </div>
          <div>
            <span class="label">快递公司</span>
            <span class="text">{{ orderAddressInfo.company_name }}</span>
          </div>
          <div>
            <span class="label">运费</span>
            <span class="text" style="color: #f24e33"
              >{{ orderAddressInfo.freight_price }}元</span
            >
          </div>
        </div>
        <div class="tips">
          <p>
            1、原则上应控制收货地址的修改范围，保证运费不变；如产生运费差价，请及时沟通患者确定承担方。
          </p>
          <p>
            2、建议先设为异常订单，避免药房误发货。修改地址后，及时通知药房刷新。
          </p>
        </div>
        <div class="newAddress bb">
          <p class="top">新收货信息</p>
          <el-form
            label-position="left"
            inline
            ref="form"
            :model="form"
            label-width="80px"
            size="small"
            :rules="rules"
          >
            <div class="flex">
              <el-form-item label="收货人" prop="consignee_name">
                <el-input v-model="form.consignee_name"></el-input>
              </el-form-item>
              <el-form-item
                label="联系电话"
                style="margin-left: 15px"
                prop="consignee_phone"
              >
                <el-input v-model="form.consignee_phone"></el-input>
              </el-form-item>
            </div>
            <div>
              <el-form-item label="省市区" prop="regions">
                <el-cascader
                  v-model="form.regions"
                  :options="regions"
                  :props="{ expandTrigger: 'hover' }"
                ></el-cascader>
              </el-form-item>
            </div>
            <div>
              <el-form-item label="详细地址" prop="address">
                <el-input
                  v-model="form.address"
                  style="width: 495px"
                ></el-input>
              </el-form-item>
            </div>

            <div>
              <p style="color: #707070; margin-bottom: 10px">
                修改收货信息备注
              </p>
              <el-form-item prop="remark">
                <el-input
                  v-model="form.remark"
                  type="textarea"
                  :rows="3"
                  style="width: 600px"
                >
                </el-input>
              </el-form-item>
            </div>
          </el-form>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addressShow = false">取 消</el-button>
        <el-button type="primary" @click="saveOrderAddressInfo('form')"
          >保存</el-button
        >
      </span>
    </el-dialog>

    <!-- 修改配送地址 -->
    <el-dialog
      title="修改配送方式"
      :visible.sync="deliveryDia"
      width="700px"
      :close-on-click-modal="false"
    >
      <div class="content bb">
        <div class="tips">
          <p>
            1、原则上不可修改配送方式；如产生运费差价，请及时沟通患者确定承担方。
          </p>
          <p>
            2、建议提前通知药房当前订单配送方式需变更，药房无异议后再进行修改。
          </p>
          <p>
            3、若配送方式修改为闪送，请准确填写经纬度信息，查看经纬度前请往：<el-link
              @click="toPush"
              >https://lbs.qq.com/getPoint</el-link
            >
          </p>
        </div>
        <div class="newAddress bb">
          <el-form
            label-position="left"
            inline
            ref="deliveryForm"
            :model="deliveryForm"
            label-width="80px"
            size="small"
            :rules="rules"
          >
            <div style="margin-bottom: 10px">
              当前订单配送方式：{{ detail.delivery | deliveryText }}
            </div>

            <el-form-item label="修改为" prop="delivery">
              <el-select v-model="deliveryForm.delivery" placeholder="请选择">
                <el-option
                  label="快递"
                  :value="1"
                  :disabled="detail.delivery == 1"
                ></el-option>
                <el-option
                  label="自提"
                  :value="2"
                  :disabled="detail.delivery == 2"
                ></el-option>
                <el-option
                  label="闪送"
                  :value="3"
                  :disabled="detail.delivery == 3"
                ></el-option>
              </el-select>
            </el-form-item>

            <template v-if="deliveryForm.delivery != 2">
              <div class="flex">
                <el-form-item label="收货人" prop="consignee_name">
                  <el-input v-model="deliveryForm.consignee_name"></el-input>
                </el-form-item>
                <el-form-item
                  label="联系电话"
                  style="margin-left: 15px"
                  prop="consignee_phone"
                >
                  <el-input v-model="deliveryForm.consignee_phone"></el-input>
                </el-form-item>
              </div>
              <div>
                <el-form-item label="省市区" prop="regions">
                  <el-cascader
                    v-model="deliveryForm.regions"
                    :options="regions"
                    :props="{ expandTrigger: 'hover' }"
                  ></el-cascader>
                </el-form-item>
              </div>
              <div>
                <el-form-item label="详细地址" prop="address">
                  <el-input
                    v-model="deliveryForm.address"
                    style="width: 495px"
                  ></el-input>
                </el-form-item>
              </div>
              <el-form-item
                v-if="deliveryForm.delivery == 3"
                label="经纬度"
                prop="lngLat"
              >
                <el-input-number
                  v-model="deliveryForm.lng"
                  :controls="false"
                  style="width: 100px"
                  placeholder="经度"
                ></el-input-number>
                <span>，</span>

                <el-input-number
                  v-model="deliveryForm.lat"
                  :controls="false"
                  style="width: 100px"
                  placeholder="纬度"
                ></el-input-number>
              </el-form-item>

              <div>
                <p style="color: #707070; margin-bottom: 10px">
                  修改收货信息备注
                </p>
                <el-form-item>
                  <el-input
                    v-model="deliveryForm.remark"
                    type="textarea"
                    :rows="3"
                    style="width: 600px"
                  >
                  </el-input>
                </el-form-item>
              </div>
            </template>
          </el-form>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="deliveryDia = false">取 消</el-button>
        <el-button type="primary" @click="saveDelivery('deliveryForm')"
          >保存</el-button
        >
      </span>
    </el-dialog>

    <!-- 药房转单 -->
    <el-dialog
      title="分配药房"
      :visible.sync="distributionShow"
      width="1200px"
      :close-on-click-modal="false"
      v-loading="loading"
    >
      <div class="dialog_content">
        <div class="left_box">
          <div class="title">当前订单信息</div>
          <div>
            <span>患者姓名：</span>
            <span style="margin-right: 20px">{{ order_info.user_name }}</span>
            <span>开方医生：</span>
            <span>{{ order_info.doctor_name }}</span>
          </div>
          <div>
            <span>处方类型：</span>
            <span style="margin-right: 20px">{{ order_info.type_name }}</span>
            <span>剂型：</span>
            <span>{{ order_info.drug_type_name }}</span>
            <span v-if="order_info.drug_machining == 1">(代煎)</span>
            <span v-if="order_info.drug_machining == 2">(茶包)</span>
          </div>
          <div>
            <span>当前所在药房：</span>
            <span style="margin-right: 20px">{{
              order_info.hospital_name
            }}</span>
          </div>
          <div>
            <span>有无转单：</span>
            <span style="margin-right: 20px">{{ order_info.is_return }}</span>
          </div>
          <div v-if="order_info.drug_type_pid == 1">
            <span>支持药杯：</span>
            <span style="margin-right: 20px">{{ order_info.box }}</span>
          </div>
          <div>
            <span>收货信息：</span>
            <span style="margin-right: 20px">{{ order_info.address }}</span>
          </div>
          <div>
            <span>配送方式：</span>
            <span
              :style="{
                marginRight: '20px',
                color: order_info.delivery != 1 ? 'red' : '',
                fontSize: order_info.delivery != 1 ? '18px' : '14px',
                fontWeight: order_info.delivery != 1 ? 'bold' : 'normal',
              }"
              >{{ order_info.delivery | deliveryText }}</span
            >
          </div>
          <div>
            <span>客服备注：</span>
            <span style="margin-right: 20px">{{ order_info.doc_remark }}</span>
          </div>
          <div>
            <span>药房打印备注：</span>
            <span style="margin-right: 20px">{{
              order_info.hospital_print_remark
            }}</span>
          </div>
          <div>
            <span>订单备注：</span>
            <span style="margin-right: 20px">{{
              order_info.platform_hospital_remark
            }}</span>
          </div>
          <div style="margin-bottom: 15px">
            <span style="color: red">注：</span>
            <span>{{ notice }}</span>
          </div>
          <div class="title">患者待支付/待发货处方信息</div>
          <div class="prebox">
            <div v-for="(item, index) in pre_list" :key="index">
              <span>处方{{ index + 1 }}：</span>
              <span>{{ item.pre_id }}({{ item.order_status }})</span>
              <span style="margin: 0 14px">{{ item.type_name }}</span>
              <span>{{ item.hospital_name }}</span>
            </div>
          </div>
        </div>
        <div class="right_box">
          <div>
            <span style="color: red"> * </span>
            <span>转单原因</span>
            <el-select
              v-model="reason"
              placeholder="请选择"
              style="margin-left: 10px"
              size="medium"
            >
              <el-option
                v-for="item in reason_list"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
          <div style="margin-top: 10px">
            <span style="margin: 0 37px 0 10px">备注</span>
            <el-input
              v-model="remark"
              placeholder="请输入内容"
              style="width: 620px"
              size="medium"
            ></el-input>
          </div>
          <div style="margin: 20px 0 10px">
            <span style="color: red"> * </span>
            分配药房
          </div>
          <div>
            <div class="flex_between">
              <span>
                <span>药房名称</span>
                <el-input
                  style="width: 140px; margin-left: 10px"
                  v-model="search_hos"
                  placeholder="请输入内容"
                  @input="getSearchHos"
                  size="medium"
                  clearable=""
                ></el-input>
              </span>
              <span v-if="show">建议：推荐不转单</span>
            </div>
          </div>
          <div class="hospitalbox">
            <el-table
              ref="multipleTable"
              :data="hospitaList"
              tooltip-effect="dark"
              style="width: 100%"
              :header-cell-style="{ background: '#F5F5F5' }"
              height="450px"
            >
              <el-table-column prop="checked" width="50">
                <template slot-scope="scope">
                  <el-checkbox
                    v-model="scope.row.checked"
                    @change="
                      (val) => {
                        hospitalChange(val, scope.row);
                      }
                    "
                  ></el-checkbox>
                </template>
              </el-table-column>
              <el-table-column label="药房名">
                <template slot-scope="scope">
                  <span>{{ scope.row.hospital_name }}</span>
                  <span v-if="scope.row.recommend == 1" class="tuijian"
                    >推荐</span
                  >
                </template>
              </el-table-column>
              <el-table-column
                label="所在地区"
                prop="address"
              ></el-table-column>
              <el-table-column
                label="支持药杯/服用次数"
                v-if="detail.drug_type == 1"
                prop="num_str"
              >
              </el-table-column>
              <el-table-column
                label="药品金额"
                prop="drug_price_str"
              ></el-table-column>
              <el-table-column
                label="加工费"
                prop="drug_machining_price"
                v-if="detail.drug_machining == 1"
              ></el-table-column>
            </el-table>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="distributionShow = false">取 消</el-button>
        <el-button type="primary" @click="distributionOrderHospitalBtn"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <!-- 关联订单 -->
    <el-dialog
      title="查看关联订单"
      :visible.sync="relationorder"
      width="800px"
      :close-on-click-modal="false"
    >
      <div class="dialog">
        <div v-for="(item, index) in orderList" :key="index">
          <div v-if="item.pre_group == 1" style="margin-top: 25px">
            <div>
              <span>订单编号：</span>
              <span>{{ item.order_sn }}</span>
              <span style="margin-left: 20px">处方号：</span>
              <span>{{ item.pre_id }}</span>
              <span style="margin-left: 20px"
                >中药材
                <span v-if="item.goods_drug_type_name"
                  >（原料：{{ item.goods_drug_type_name }}）</span
                >
              </span>
              <span style="margin-left: 20px">{{ item.hospital_name }}</span>
            </div>
            <div style="border: solid 1px #c9cbd6; margin-top: 10px">
              <el-table
                ref="multipleTable"
                :data="item.item_list"
                tooltip-effect="dark"
                style="width: 100%"
                :header-cell-style="{ background: '#F5F5F5' }"
              >
                <el-table-column prop="generic_name" label="药品名称">
                  <template slot-scope="scope">
                    <span>{{ scope.row.generic_name }}</span>
                    <span v-if="scope.row.is_national_standard == 1">(新)</span>
                    <div
                      v-if="
                        scope.row.is_national_standard == 1 &&
                        item.is_sure_national_standard == 1 &&
                        scope.row.dosage_unit == 2
                      "
                    >
                      (原{{ scope.row.item_use_level }}g)
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="item_use_level"
                  label="开方量（按饮片）"
                  width="132"
                >
                  <template slot-scope="scope">
                    <div
                      v-if="
                        scope.row.is_national_standard == 1 &&
                        item.is_sure_national_standard == 1
                      "
                    >
                      {{ scope.row.national_standard_level }}
                    </div>
                    <span v-else>{{ scope.row.item_use_level }}g</span>
                  </template>
                </el-table-column>
                <el-table-column label="规格" prop="sku_name">
                </el-table-column>
                <el-table-column label="当量" prop="conversion">
                </el-table-column>
                <el-table-column label="单价" prop="price"> </el-table-column>

                <el-table-column label="数量" prop="num">
                  <template slot-scope="scope">
                    <span v-if="scope.row.dosage_unit != 2"
                      >{{ scope.row.num }}{{ scope.row.dosage_unit_name }}</span
                    >
                    <span v-else>{{ scope.row.num }}g</span>
                  </template>
                </el-table-column>

                <el-table-column label="金额（元）">
                  <template slot-scope="scope">
                    <span>{{ scope.row.money }}</span>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
          <div style="margin-top: 25px" v-if="item.pre_group == 3">
            <div>
              <span>订单编号：</span>
              <span>{{ item.order_sn }}</span>
              <span style="margin-left: 20px">处方号：</span>
              <span>{{ item.pre_id }}</span>
              <span style="margin-left: 20px">成药</span>
              <span style="margin-left: 20px">{{ item.hospital_name }}</span>
            </div>
            <div style="border: solid 1px #c9cbd6; margin-top: 10px">
              <el-table
                ref="multipleTable"
                :data="item.pm_list"
                tooltip-effect="dark"
                style="width: 100%"
                :header-cell-style="{ background: '#F5F5F5' }"
              >
                <el-table-column
                  prop="pm_name"
                  label="药品名称"
                ></el-table-column>
                <el-table-column label="规格" prop="pm_spec"> </el-table-column>
                <el-table-column label="单价" prop="price"> </el-table-column>
                <el-table-column label="单位" prop="pm_unit"> </el-table-column>
                <el-table-column label="数量" prop="item_use_level">
                </el-table-column>
                <el-table-column label="金额（元）">
                  <template slot-scope="scope">
                    <span>{{
                      (scope.row.item_use_level * scope.row.price).toFixed(4)
                    }}</span>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
          <div style="margin-top: 25px" v-if="item.pre_group == 2">
            <div>
              <span>订单编号：</span>
              <span>{{ item.order_sn }}</span>
              <span style="margin-left: 20px">处方号：</span>
              <span>{{ item.pre_id }}</span>
              <span style="margin-left: 20px">养生方</span>
              <span style="margin-left: 20px">{{ item.hospital_name }}</span>
            </div>
            <div style="border: solid 1px #c9cbd6; margin-top: 10px">
              <el-table
                ref="multipleTable"
                :data="item.oil_item_list"
                tooltip-effect="dark"
                style="width: 100%"
                :header-cell-style="{ background: '#F5F5F5' }"
              >
                <el-table-column
                  prop="oil_name"
                  label="药品名称"
                ></el-table-column>
                <el-table-column label="规格" prop="oil_spec">
                </el-table-column>
                <el-table-column label="单价" prop="price"> </el-table-column>
                <el-table-column label="单位" prop="oil_unit">
                </el-table-column>
                <el-table-column label="数量" prop="item_use_level">
                </el-table-column>
                <el-table-column label="金额（元）">
                  <template slot-scope="scope">
                    <span>{{
                      (scope.row.item_use_level * scope.row.price).toFixed(4)
                    }}</span>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
        <div class="pricebox">
          <div class="priceitem flex_between">
            <span>中药材</span>
            <span>
              <span v-if="orderData.single_price">
                <span>{{ orderData.single_price }}</span>
                <span>×</span>
                <span>{{ orderData.total_num }}</span>
                <span>=</span>
              </span>
              <span>{{ orderData.drug_price }}元</span>
            </span>
          </div>
          <div class="priceitem flex_between">
            <span>成药</span>
            <span>{{ orderData.pm_price }}元</span>
          </div>
          <div class="priceitem flex_between">
            <span>养生膏方</span>
            <span>{{ orderData.oil_price }}元</span>
          </div>
          <div class="priceitem flex_between">
            <span>诊后管理费 </span>
            <span>{{ orderData.consult_drug_price }}元</span>
          </div>
          <div class="priceitem flex_between">
            <span>诊金</span>
            <span>{{ orderData.consulting_gold }}元</span>
          </div>
          <div class="priceitem flex_between">
            <span>优惠金额</span>
            <span>-{{ orderData.discount_price }}元</span>
          </div>
          <div class="priceitem flex_between">
            <span>运费</span>
            <span
              >{{
                orderData.freight_price - orderData.freight_coupon_money
              }}元<span v-if="orderData.freight_coupon_id"
                >&nbsp;优惠券抵扣{{ orderData.freight_coupon_money }}元</span
              ></span
            >
          </div>
          <div class="priceitem flex_between">
            <span>礼品卡金额</span>
            <span>-{{ orderData.gift_money }}元</span>
          </div>
          <div class="priceitem flex_between">
            <span style="font-weight: 700">合计</span>
            <span
              >{{
                orderData.total_price ? orderData.total_price.toFixed(2) : "0"
              }}元</span
            >
          </div>
        </div>
      </div>
    </el-dialog>
    <!-- 修改备注 -->
    <el-dialog
      title="编辑备注信息"
      :visible.sync="hospitalremark"
      width="400px"
      :close-on-click-modal="false"
    >
      <div style="padding: 20px; text-align: left">
        <div>备注</div>
        <el-input
          v-model="platform_hospital_remark"
          maxlength="30"
          placeholder="30个字以内"
          style="margin: 10px 0 20px"
        ></el-input>
        <div style="text-align: center">
          <el-button @click="hospitalremark = false" plain size="medium"
            >取消</el-button
          >
          <el-button @click="addRemark" type="primary" size="medium"
            >确定</el-button
          >
        </div>
      </div>
    </el-dialog>
    <!-- 分方设置 -->
    <el-dialog title="分方设置" :visible.sync="separateDia" center width="30%">
      <div class="content">
        <el-form
          ref="separateFormRef"
          :model="separateForm"
          label-width="140px"
          size="small"
        >
          <el-form-item label="是否分方" prop="is_separate">
            <el-radio-group v-model="separateForm.is_separate">
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <template v-if="separateForm.is_separate == 1">
            <el-form-item label="分格" prop="separate_num">
              <el-input-number
                v-model="separateForm.separate_num"
                :min="2"
                :max="9"
                :precision="0"
                :controls="false"
                style="width: 90px"
              ></el-input-number>
            </el-form-item>
            <el-form-item label="是否发送分方短信" prop="is_sms">
              <el-radio-group v-model="separateForm.is_sms">
                <el-radio :label="1">是</el-radio>
                <el-radio :label="0">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </template>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="separateDia = false">取 消</el-button>
        <el-button type="primary" @click="separateDiaConfirm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import order from "../../../api/order";
import platform from "../../../api/platform";
import DocMsg from "../../../components/common/DocMsg.vue";
import ReturnVisit from "../../../components/common/ReturnVisit.vue";
import dayjs from "dayjs";
import common from "../../../api/common";
export default {
  name: "orderDetail",
  data() {
    const validateLngLat = (rule, value, callback) => {
      const { lng, lat } = this.deliveryForm;
      // 如果两个字段都为空，不验证（通过）
      if (!lng && !lat) {
        callback(new Error("请填写经纬度"));
      }
      // 如果其中一个有值但另一个为空，则报错
      else if ((lng && !lat) || (!lng && lat)) {
        callback(new Error("请填写经纬度"));
      } else {
        callback();
      }
    };
    return {
      express: false,
      order_status: 1,
      detail: {},
      drugs_list: [],
      oil_list: [],
      pm_list: [],
      express_data: {},
      addressShow: false,
      orderAddressInfo: {}, //原收货信息
      form: {
        consignee_name: "",
        consignee_phone: "",
        address: "",
        remark: "",
        regions: [],
        freight_price: "",
      }, //新地址信息

      regions: [], //地区
      rules: {
        consignee_name: [
          { required: true, message: "请输入收货人姓名", trigger: "blur" },
        ],
        delivery: [{ required: true, message: "请选择", trigger: "change" }],
        consignee_phone: [
          { required: true, message: "请输入联系电话", trigger: "change" },
        ],
        regions: [{ required: true, message: "请选择地区", trigger: "change" }],
        address: [
          { required: true, message: "请输入详细地址", trigger: "blur" },
        ],
        remark: [
          { required: true, message: "请输入备注信息", trigger: "blur" },
        ],
        lngLat: [
          {
            required: true,
            validator: validateLngLat,
            trigger: "blur",
          },
        ],
      },
      distributionShow: false,
      type_name: "",
      hospitaList: [],
      hospitalData: [],
      reason_list: [
        {
          label: "库存不足",
          value: "库存不足",
        },
        {
          label: "暂停营业",
          value: "暂停营业",
        },
        {
          label: "物流限制",
          value: "物流限制",
        },
        {
          label: "其他",
          value: "其他",
        },
      ],
      reason: "",
      remark: "",
      relationorder: false,
      orderList: [],
      orderData: {},
      hospitalremark: false,
      platform_hospital_remark: "",
      doc_msg: false,
      doctorId: "",
      search_hos: "",
      show: 1,
      confirm: 1,
      order_info: {},
      pre_list: [],
      notice: "",
      loading: false,
      return_visit: false,
      preId: 0,
      visitName: "prescription",
      visitType: 3,
      activeIndexDia: "1",
      separateDia: false,
      separateForm: {
        is_separate: 0,
        separate_num: 2,
        is_sms: 0,
      },
      deliveryDia: false,
      deliveryForm: {
        delivery: "",
        consignee_name: "",
        consignee_phone: "",
        address: "",
        remark: "",
        regions: [],
        freight_price: "",
        lng: undefined,
        lat: undefined,
      },
    };
  },
  components: {
    DocMsg,
    ReturnVisit,
  },
  filters: {
    deliveryText(val) {
      switch (val) {
        case 1:
          return "快递";
        case 2:
          return "自提";
        case 3:
          return "闪送";
      }
    },
    freight_price_type_text(val) {
      switch (val) {
        case 1:
          return "(运费包邮券)";
        case 2:
          return "(加购包邮)";
        case 3:
          return "(合并支付包邮)";
        case 4:
          return "(满足药房设置的包邮条件)";
      }
    },
  },
  computed: {
    active() {
      switch (this.order_status) {
        case 1:
          return 2;
        case 2:
          return 2;
        case 3:
          return 3;
        case 4:
          return 4;
      }
    },
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
    consultDrugOrderInfoText() {
      if (!Object.keys(this.detail).length) {
        return "";
      }
      let info = this.detail.consult_drug_order_info;
      let status = Array.isArray(info) ? -1 : info.status;
      switch (status) {
        case -1:
          return "<span>无诊后病程管理</span>";
        case 1:
          return `<span>总周期：${info.total_cycle}</span>&nbsp;&nbsp;<span>状态：${info.status_str}</span>`;
        case 2:
          return `<span>总周期：${info.total_cycle}</span>&nbsp;&nbsp;<span>状态：${info.status_str}</span>&nbsp;&nbsp;<span>${info.curr_cycle}</span> `;
        case 3:
          return `<span>总周期：${info.total_cycle}</span>&nbsp;&nbsp;<span>状态：${info.status_str}</span>`;
      }
    },
  },
  methods: {
    separateText(val) {
      switch (val) {
        case 0:
          return "否";
        case 1:
          return `分为${this.detail.separate_num}格`;
      }
    },
    //医生信息概要
    showDocMsg(doctor_id) {
      this.doctorId = doctor_id;
      this.doc_msg = !this.doc_msg;
    },
    //获取详情
    getDetail() {
      let order_id = this.$route.query.order_id;
      order.getOrderInfo({ order_id }).then((res) => {
        if (res.code == 0) {
          this.detail = res.data.info;
          this.oil_list = res.data.info.oil_item_list;
          this.pm_list = res.data.info.pm_list;
          this.drugs_list = res.data.info.item_list;
          //支付订单时间
          this.detail.create_time = platform.timestampToTime(
            this.detail.create_time
          );
          //药房发货时间
          this.detail.send_time = this.detail.send_time
            ? platform.timestampToTime(this.detail.send_time)
            : "";
          //客户收货时间
          this.detail.completion_time = this.detail.completion_time
            ? platform.timestampToTime(this.detail.completion_time)
            : "";
          //退款时间
          this.detail.refund_time = this.detail.refund_time
            ? platform.timestampToTime(this.detail.refund_time)
            : "";
          //等待时间
          this.detail.refund_sub_time = this.detail.refund_sub_time
            ? dayjs.unix(this.detail.refund_sub_time).format("YYYY-MM-DD HH:mm")
            : "";
          this.order_status = res.data.info.status;
        }
      });
    },
    //查看物流信息
    orderExpress() {
      let order_id = this.$route.query.order_id;
      order.getOrderLogisticsInfo({ order_id }).then((res) => {
        if (res.code == 0) {
          this.express_data = res.data.info;
          this.express_data.logistics_list[0].type = "primary";
          this.express_data.logistics_list[0].size = "large";
        }
      });
      setTimeout(() => {
        this.express = true;
      }, 500);
    },
    //确认收货
    confirmReceipt() {
      let loading = null;
      this.$confirm(
        "请先与收货人取得联系，明确收货人已经收到货，再进行确认",
        "提示",
        {
          confirmButtonText: "是，已确认",
          cancelButtonText: "否，取消",
        }
      )
        .then(() => {
          loading = this.$loading();
          this.express = false;
          let data = {
            order_id: this.$route.query.order_id,
          };
          return this.axios.post("platform/order/confirmReceipt", data);
        })
        .then(() => {
          this.$message({
            type: "success",
            message: "确认成功!",
          });
          loading.close();
          this.getDetail();
        })
        .catch(() => {
          loading.close();
        });
    },
    //返回
    back() {
      history.back();
    },
    //获取省市区列表
    getRegion() {
      let url = "platform/platform/getProvinceCityDistrict";
      this.axios.post(url).then((res) => {
        let regions = res.data.list;
        this.transRegions(regions);
        this.regions = regions;
      });
    },
    transRegions(tree) {
      tree.forEach((item) => {
        if (item.city || item.district) {
          item.children = item.city || item.district;
          delete item.city;
          delete item.district;
          this.transRegions(item.children);
        }
        if (item.province_id) {
          item.value = item.province_id;
          delete item.province_id;
        }
        if (item.city_id) {
          item.value = item.city_id;
          delete item.city_id;
        }
        if (item.district_id) {
          item.value = item.district_id;
          delete item.district_id;
        }

        if (item.name) {
          item.label = item.name;
          delete item.name;
        }
      });
    },
    showDeliveryBtn() {
      this.getRegion();
      let {
        consignee_name,
        consignee_phone,
        address,
        remark,
        freight_price,
        lng,
        lat,
        province_id,
        city_id,
        district_id,
      } = this.detail.address_info;
      let regions = [province_id, city_id, district_id];
      this.deliveryForm = {
        consignee_name,
        consignee_phone,
        address,
        remark,
        regions,
        freight_price,
        lng,
        lat,
      };
      console.log(this.deliveryForm);

      this.deliveryDia = true;
    },
    //打开修改信息
    showAddress() {
      this.getRegion();
      this.getOrderAddressInfo();
      this.addressShow = true;
    },
    //获取原收货信息
    getOrderAddressInfo() {
      let data = {
        order_id: this.$route.query.order_id,
      };
      this.axios
        .post("platform/order/getOrderAddressInfo", data)
        .then((res) => {
          this.orderAddressInfo = res.data.info;
        });
    },
    //保存新修改地址
    saveOrderAddressInfo(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let form = this.form;
          if (
            !(
              form.consignee_name &&
              form.consignee_phone &&
              form.address &&
              form.remark &&
              form.regions.length > 0
            )
          ) {
            this.$message.error("请填写完新地址信息");
            return;
          }
          let data = {
            order_id: this.$route.query.order_id,
            consignee_name: form.consignee_name,
            consignee_phone: form.consignee_phone,
            address: form.address,
            remark: form.remark,
            province_id: form.regions[0],
            city_id: form.regions[1],
            district_id: form.regions[2],
          };
          this.axios
            .post("platform/order/saveOrderAddressInfo", data)
            .then((res) => {
              this.$message.success("修改成功");
              this.form = {
                consignee_name: "",
                consignee_phone: "",
                address: "",
                remark: "",
                regions: [],
                freight_price: "",
              };
              this.addressShow = false;
              this.getDetail();
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    //保存配送方式地址
    saveDelivery(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let order_id = this.$route.query.order_id;
          let params = _.pick(this.deliveryForm, [
            "delivery",
            "consignee_name",
            "consignee_phone",
            "address",
            "remark",
            "lng",
            "lat",
          ]);
          let regions_obj = {
            province_id: this.deliveryForm.regions[0],
            city_id: this.deliveryForm.regions[1],
            district_id: this.deliveryForm.regions[2],
          };
          params = Object.assign(params, { order_id }, regions_obj);

          this.axios
            .post("platform/order/updateOrderDelivery", params)
            .then((res) => {
              this.$message.success("修改成功");
              this.deliveryForm = {
                delivery: "",
                consignee_name: "",
                consignee_phone: "",
                address: "",
                remark: "",
                regions: [],
                freight_price: "",
              };
              this.deliveryDia = false;
              this.getDetail();
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // //获取新运费
    // getNewFreightPrice() {
    //   if (this.form.regions.length == 0) return;
    //   let data = {
    //     hospital_id: this.detail.hospital_id,
    //     total_num: this.detail.total_num,
    //     pre_id: this.detail.pre_id,
    //     drug_type: this.detail.drug_type,
    //     shipping_id: this.detail.shipping_id,
    //     city_id: this.form.regions[1]
    //   };
    //   this.axios
    //     .post('platform/order/getNewFreightPrice', data)
    //     .then((res) => {
    //       this.form.freight_price = res.data.freight_price;
    //     })
    //     .catch((err) => {
    //       this.form.regions = [];
    //     });
    // },
    //修改单号
    editOrder() {
      this.$prompt("请输入快递单号", "", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(({ value }) => {
          let data = {
            express_no: value,
            order_id: this.$route.query.order_id,
          };
          this.axios
            .post("platform/order/amendmentNumber", data)
            .then((res) => {
              if (res.code == 0) {
                this.$message.success("修改成功");
                this.getDetail();
              }
            });
        })
        .catch(() => {});
    },
    getSearchHos(value) {
      if (value) {
        let arr = [];
        this.hospitalData.map((item) => {
          if (item.hospital_name.indexOf(value) != -1) {
            arr.push(item);
          }
        });
        this.hospitaList = arr;
      } else {
        this.hospitaList = this.hospitalData;
      }
    },
    //可分配药房列表
    getreturnhospitalist() {
      if (this.detail.delivery == 2) {
        this.$confirm(
          "该订单为自提订单，转单后自提点和发药药房不在同一区域！请核实是否继续转单",
          "提示",
          {
            closeOnClickModal: false,
            confirmButtonText: "确定",
            cancelButtonText: "取消",
          }
        )
          .then(() => {
            this.loading = true;
            let pre_id = this.detail.pre_id;
            this.axios
              .post("platform/Order/getReturnHospitaList", { pre_id })
              .then((res) => {
                this.order_info = res.data.order_info;
                this.notice = res.data.notice;
                this.pre_list = res.data.pre_list;
                this.show = res.data.show;
                this.confirm = res.data.confirm;
                this.hospitalData = res.data.hospital.map((item) => {
                  item.checked = false;
                  if (item.day_num) {
                    let day_str = item.day_num.replace(/,/g, "或");
                    let day_arr = day_str.split("&");
                    let str_arr = [];
                    day_arr.map((i) => {
                      let arr = i.split("|");
                      let str = arr[0] + "格药杯每剂分" + arr[1] + "服用";
                      str_arr.push(str);
                    });
                    item.num_str = "支持" + str_arr.toString();
                  }
                  return item;
                });
                this.hospitaList = this.hospitalData;
                this.loading = false;
              })
              .catch(() => {
                this.loading = false;
              });
            this.distributionShow = true;
          })
          .catch();
      } else {
        this.loading = true;
        let pre_id = this.detail.pre_id;
        this.axios
          .post("platform/Order/getReturnHospitaList", { pre_id })
          .then((res) => {
            this.order_info = res.data.order_info;
            this.pre_list = res.data.pre_list;
            this.notice = res.data.notice;
            this.show = res.data.show;
            this.confirm = res.data.confirm;
            this.hospitalData = res.data.hospital.map((item) => {
              item.checked = false;
              if (item.day_num) {
                let day_str = item.day_num.replace(/,/g, "或");
                let day_arr = day_str.split("&");
                let str_arr = [];
                day_arr.map((i) => {
                  let arr = i.split("|");
                  let str = arr[0] + "格药杯每剂分" + arr[1] + "服用";
                  str_arr.push(str);
                });
                item.num_str = "支持" + str_arr.toString();
              }
              return item;
            });
            this.hospitaList = this.hospitalData;

            this.loading = false;
          })
          .catch(() => {
            this.loading = false;
          });
        this.distributionShow = true;
      }
    },
    //药房选择
    hospitalChange(val, row) {
      this.hospitaList.forEach((ele) => {
        ele.checked = false;
      });
      row.checked = val;
    },
    // 确定分配
    isRealStock(hospital) {
      let params = {
        order_id: this.order_info.order_id,
        hospital_id: hospital.hospital_id,
      };
      common.isRealStock(params).then((res) => {
        let { code, data } = res;
        if (data.status === 1) {
          this.$confirm(
            `处方中${data.generic_name}的库存不足，确定将当前订单转到${hospital.hospital_name}吗？`,
            "提示",
            {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
            }
          )
            .then(() => {
              let params = {
                order_id: this.order_info.order_id,
                hospital_id: hospital.hospital_id,
                hospital_name: hospital.hospital_name,
                return_desc: this.remark
                  ? this.reason + "-" + this.remark
                  : this.reason,
              };
              this.axios
                .post("platform/Order/distributionOrderHospital", params)
                .then(() => {
                  this.$message.success("分配成功");
                  this.getDetail();
                  this.distributionShow = false;
                });
            })
            .catch(() => {});
        } else {
          let params = {
            order_id: this.order_info.order_id,
            hospital_id: hospital.hospital_id,
            hospital_name: hospital.hospital_name,
            return_desc: this.remark
              ? this.reason + "-" + this.remark
              : this.reason,
          };
          this.axios
            .post("platform/Order/distributionOrderHospital", params)
            .then(() => {
              this.$message.success("分配成功");
              this.getDetail();
              this.distributionShow = false;
            });
        }
      });
    },
    distributionOrderHospital(hospital) {
      let params = {
        order_id: this.order_info.order_id,
        hospital_id: hospital.hospital_id,
        hospital_name: hospital.hospital_name,
        return_desc: this.remark
          ? this.reason + "-" + this.remark
          : this.reason,
      };
      this.axios
        .post("platform/Order/distributionOrderHospital", params)
        .then(() => {
          this.$message.success("分配成功");
          this.getDetail();
          this.distributionShow = false;
        });
    },
    //分配药房
    distributionOrderHospitalBtn() {
      if (!this.reason) {
        this.$message.error("请选择转单原因");
        return false;
      }
      let hospital = this.hospitaList.find((ele) => {
        return ele.checked == true;
      });
      if (!hospital) {
        this.$message.error("请选择分配的药房");
        return false;
      }

      if (hospital.drug_lack_str != "") {
        this.$confirm(
          `处方中${hospital.drug_lack_str}在${hospital.hospital_name}药房中缺药，确定要继续转单吗？`,
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
          }
        )
          .then(() => {
            this.confirmFn(hospital);
          })
          .catch(() => {});
      } else {
        this.confirmFn(hospital);
      }
    },
    // 同个患者其他处方类型方法
    confirmFn(hospital) {
      if (this.confirm) {
        this.$confirm(
          `当前患者有其他处方类型的处方在当前药房，确定将当前订单分配到${hospital.hospital_name}吗？`,
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
          }
        )
          .then(() => {
            if (hospital.open_saas_stock == 1) {
              this.isRealStock(hospital);
            } else {
              this.distributionOrderHospital(hospital);
            }
          })
          .catch(() => {});
      } else {
        if (hospital.open_saas_stock == 1) {
          this.isRealStock(hospital);
        } else {
          this.distributionOrderHospital(hospital);
        }
      }
    },
    //获取关联订单
    getRelation() {
      let order_pid = this.detail.order_pid;
      this.axios
        .post("platform/order/joinedorderitem", { order_pid })
        .then((res) => {
          this.orderData = {
            gold_join: res.data.gold_join, //诊金是否加入药品金额，0不加入，1加入
            drug_price: res.data.drug_price, //中药材金额
            pm_price: res.data.pm_price, //成药金额
            oil_price: res.data.oil_price, //养生方金额
            freight_price: res.data.freight_price, //运费
            consult_drug_price: res.data.consult_drug_price, //诊后管理费
            discount_price: res.data.discount_price, //优惠金额
            consulting_gold: res.data.consulting_gold, //诊金
            total_price: res.data.total_price, //总计
            single_price: res.data.single_price, //总计
            total_num: res.data.total_num, //总计
            gift_money: res.data.gift_money, //总计
            freight_coupon_money: res.data.freight_coupon_money,
          };
          this.orderList = res.data.list;
          this.relationorder = true;
        });
    },
    //添加备注
    addRemark() {
      if (!this.platform_hospital_remark) {
        this.$message.error("请填写备注");
        return false;
      }
      let data = {
        order_id: this.$route.query.order_id,
        platform_hospital_remark: this.platform_hospital_remark,
      };
      this.axios
        .post("platform/order/editOrderRemarkInfo", data)
        .then((res) => {
          if (res.code == 0) {
            this.$message.success("保存成功");
            this.hospitalremark = false;
            this.getDetail();
          }
        });
    },
    // 查看处方
    viewPrescription() {
      const routeData = this.$router.resolve({
        path: "/home/yewu/chufangdetail",
        query: {
          pre_id: this.detail.pre_id,
        },
      });
      window.open(routeData.href, "_blank");
    },
    //回访
    toReturn() {
      this.preId = this.detail.pre_id;
      this.return_visit = !this.return_visit;
    },
    //设置加急
    setUrgent() {
      let data = {
        pre_id: this.detail.pre_id,
        platform_urgent: this.detail.platform_urgent,
      };
      this.axios.post("platform/order/setUrgent", data).then((res) => {
        if (res.code == 0) {
          this.$message.success("保存成功");
          this.getDetail();
        }
      });
    },
    // 分方设置
    separateDiaOpen() {
      this.separateForm.is_separate = this.detail.is_separate;
      this.separateForm.separate_num = this.detail.separate_num;
      this.separateDia = true;
    },
    separateDiaConfirm() {
      let params = Object.assign({}, this.separateForm);
      params.order_id = this.$route.query.order_id;
      common.setSeparate(params).then((res) => {
        let { code } = res;
        if (code === 0) {
          this.$message.success("修改成功");
          this.separateDia = false;
          this.getDetail();
        }
      });
    },
    // 设置是否已开具发票
    setIsInvoice() {
      let params = {
        order_id: this.$route.query.order_id,
        is_send_invoice: this.detail.is_send_invoice,
      };
      order.setIsInvoice(params).then((res) => {
        let { code } = res;
        if (code === 0) {
          this.$message.success("保存成功");
          this.getDetail();
        }
      });
    },
    // 导出订单药材及费用
    excelexport() {
      common
        .exportOrderTrug({ order_id: this.$route.query.order_id })
        .then((res) => {
          let { code, data } = res;
          if (code == 0) {
            let host = `${document.location.protocol}//${window.location.host}${data.url}`;
            window.open(host);
          }
          loading.close();
        })
        .catch((err) => {
          loading.close();
        });
    },
    // 问诊记录详情
    toDetails(consult_id) {
      this.$router.push({
        path: "/home/yewu/wenzhendetail",
        query: {
          consult_id,
        },
      });
    },
    toPush() {
      window.open("https://lbs.qq.com/getPoint", "_blank");
    },
  },
  created() {
    this.getDetail();
  },
};
</script>
<style lang="scss" scoped>
.phone-box {
  width: 18px;
  height: 18px;
  padding: 0 6px;
  cursor: pointer;
}
.mystep_bar {
  width: 1070px;
  height: 30px;
  margin: 0 auto 50px;
  position: relative;

  .step1 {
    position: absolute;
    top: 2px;
    left: 28px;
    font-weight: 600;
    color: #669961;
  }
  .step2 {
    position: absolute;
    top: 2px;
    left: 295px;
    font-weight: 600;
  }
  .step3 {
    position: absolute;
    top: 2px;
    left: 562px;
    font-weight: 600;
  }
  .step4 {
    position: absolute;
    top: 2px;
    left: 830px;
    font-weight: 600;
  }
}
.container {
  padding: 20px;
  box-sizing: border-box;
  text-align: left;
  background: #fff;
}
.steptext {
  display: flex;
  padding: 10px 30px;
  text-align: left;
}
.statusbox {
  width: 100%;
  height: 60px;
  text-align: left;
  background-color: #e5f4e4;
  color: #669961;
  padding: 0 24px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 16px;
}
.title {
  font-size: 16px;
  font-weight: 600;
  color: #333333;
  margin-bottom: 12px;
}
.little_title {
  margin-right: 10px;
}

.infobox {
  text-align: left;
  border: solid 1px #cfcece;
  padding: 20px;
  margin-bottom: 30px;
  color: #747981;
}
.totalprice {
  height: 40px;
  background-color: #fffef0;
  border: solid 1px #cfcece;
  border-top: solid 1px transparent;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 10px;
  box-sizing: border-box;
}
.price {
  width: 260px;
  display: flex;
  height: 24px;
  justify-content: space-between;
  align-items: center;
  color: #747981;
}
.cancel {
  width: 100%;
  background: #e7e7e7;
  text-align: left;
  padding: 30px 20px;
  box-sizing: border-box;
  color: #747981;
}
.content {
  padding: 20px 20px 0;
  text-align: left;
  p {
    margin: 0;
  }
  .top {
    color: #262626;
    font-weight: bold;
    margin-bottom: 10px;
  }
  .info {
    margin-bottom: 10px;
    div + div {
      margin-left: 30px;
    }
    .label {
      color: #262626;
      margin-right: 10px;
    }
    .text {
      color: #666666;
    }
  }
  .tips {
    p {
      color: #fc8740;
      line-height: 25px;
    }
  }
  .newAddress {
    background-color: #e5f4e4;
    padding: 15px;
    margin-top: 10px;
  }
}
.dialog_content {
  display: flex;
  justify-content: space-between;
  text-align: left;
  box-sizing: border-box;
  .title {
    font-weight: 700;
    font-size: 15px;
    margin-bottom: 6px;
  }
  .left_box {
    width: 450px;
    padding: 15px 15px 0;
    box-sizing: border-box;
    line-height: 24px;
  }
  .right_box {
    width: 750px;
    padding: 15px 15px 0;
    border-left: 1px solid #ccc;
    box-sizing: border-box;
  }
  .prebox {
    border: 1px solid #ccc;
    padding: 10px;
    line-height: 30px;
    height: 343px;
    overflow: hidden;
    overflow-y: scroll;
  }
  .box {
    max-height: 300px;
    overflow: auto;
    padding: 0 10px;
  }
  .hospitalbox {
    border: 1px solid #ccc;
    margin-top: 14px;
  }
  .el-checkbox {
    margin-right: 15px;
  }
}
.dialog {
  padding: 0 15px 15px;

  text-align: left;
}
.pricebox {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  .priceitem {
    width: 200px;
    line-height: 24px;
  }
}
.remark {
  font-size: 14px;
  margin-left: 20px;
}
.tuijian {
  color: red;
  display: inline-block;
  font-size: 10px;
  border: 1px solid red;
  padding: 0 3px;
  margin-left: 10px;
}
</style>
<style lang="scss">
.mystep_bar .el-step__head {
  width: 170px;
}
.mystep_bar .el-step.is-center .el-step__head {
  text-align: left;
}
</style>
